/* istanbul ignore file */
import styled, { css } from 'styled-components';

const Card = styled.div<{ $palette: 'blue' | 'purple' }>(
  ({ theme, $palette }) => css`
    width: 100%;
    max-width: 1102px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: ${theme.sz.s8};
    padding-bottom: ${theme.sz.s8};
    padding-left: ${theme.sz.s4};
    padding-right: ${theme.sz.s4};
    border-radius: ${theme.bo.medium};
    border-style: solid;
    border-width: 3px;
    overflow: hidden;

    ${
      $palette === 'blue' &&
      css`
        background-color: ${theme.co.secondary0};
        border-color: ${theme.co.secondary10};
      `
    }

    ${
      $palette === 'purple' &&
      css`
        background-color: #260202; // No alternatives in theme, universal red
        border-color: ${theme.co.error20};
      `
    }

    @media (min-width: ${theme.sz.md}) {
      padding-top: ${theme.sz.s10};
      padding-bottom: ${theme.sz.s10};
      padding-left: ${theme.sz.s10};
      padding-right: ${theme.sz.s10};
    }
  `,
);

export default Card;
